import React, { Component, Fragment } from 'react';
import reduxFetch from 'react-redux-fetch';
import PropTypes from 'prop-types';
import { Header } from 'nallian-shared-ui/lib/components';
import { createOrganisationsUrl } from '../helpers/createOrganisationsUrl';
import apiRoutes from '../../../app/api/routes';

export const ORGANISATIONS_RESOURCE = 'organisations';

export default ComposedComponent => {
  class Organisations extends Component {
    getOrganisationsForSelectOptions = () =>
      (this.props.organisationsFetch.value || []).map(item => ({
        key: item.id,
        value: item.id,
        text: item.organisationName,
        content: (
          <Fragment key={item.id}>
            <Header as="h5">{item.organisationName}</Header>
            {item.city}, {item.countryCode}
          </Fragment>
        ),
      }));

    render() {
      return (
        <ComposedComponent
          getOrganisationsForSelectOptions={this.getOrganisationsForSelectOptions}
          {...this.props}
        />
      );
    }
  }

  Organisations.propTypes = {
    organisationsFetch: PropTypes.object.isRequired,
  };
  return reduxFetch([
    {
      resource: ORGANISATIONS_RESOURCE,
      method: 'get',
      request: (sort, page, pageSize, filter) => ({
        url: createOrganisationsUrl(sort, page, pageSize, filter),
      }),
    },
    {
      resource: 'organisationsPage',
      method: 'get',
      request: (sort, page, pageSize, filter) => ({
        url: createOrganisationsUrl(sort, page, pageSize, filter),
        meta: {
          mergeWithOtherList: {
            resource: ORGANISATIONS_RESOURCE,
            idProp: 'id',
          },
        },
      }),
    },
    {
      resource: {
        name: 'deleteOrganisation',
        action: 'organisation',
      },
      method: 'delete',
      request: (id, callback) => ({
        url: apiRoutes.deleteOrganisation(id),
        meta: {
          id,
          callback,
          updateOtherList: {
            resource: ORGANISATIONS_RESOURCE,
            idProp: 'id',
            id,
            values: {
              activeStateId: 4, // Set as state deleted
            },
          },
        },
      }),
    },
  ])(Organisations);
};
